"use client"

import { useClientTranslation } from "@/modules/App/components/i18n/i18n.client"
import { Plus } from "lucide-react"
import Image from "next/image"

import * as styles from "./add-a-pet-card.styled"

type AddAPetCardProps = {
  onClick: () => void
}

export const AddAPetCard = ({ onClick }: AddAPetCardProps) => {
  const { t } = useClientTranslation("tribe-page")

  return (
    <button
      type="button"
      onClick={onClick}
      className={styles.root}
      aria-label={t("add-pet-label")}
    >
      <span className={styles.icon} aria-hidden>
        <Image src="/img/illus/plus.svg" alt="" width={40} height={40} />
      </span>
      <span className={styles.label}>{t("add-pet-label")}</span>
      <Plus className={styles.plusIcon} aria-hidden />
    </button>
  )
}
